import React from 'react'
import Link from 'next/link'
import Image from 'next/image'

import {logEvent} from '@lib/gtm'

import {IconFacebook, IconLinkedin} from '@components/Icon'
import {Form} from './Form'

interface SiteFooterWithFormProps {
  className?: string
}
const SiteFooterWithForm = ({className = ''}: SiteFooterWithFormProps) => {
  const ADDRESS =
    '1778 อาคารซัมเมอร์ฮับ ออฟฟิศ, ชั้น 6<br/> ถนนสุขุมวิท แขวงพระโขนง เขตคลองเตย <br/> กรุงเทพมหานคร 10110 <br/> ประเทศไทย'

  return (
    <div className={`FooterWithForm ${className}`}>
      <div className='container'>
        <div className='container__info'>
          <div className='address'>
            <Link href='/'>
              <a
                className='Nav__logo-brand'
                title='datawow.co.th'
                onClick={() => {
                  logEvent({
                    ga: {
                      category: 'Homepage',
                      action: 'Click Homepage',
                    },
                  })
                }}
              >
                <Image
                  src='/images/logo-white.svg'
                  alt='datawow logo'
                  width='296px'
                  height='46px'
                />
              </a>
            </Link>
            <div dangerouslySetInnerHTML={{__html: ADDRESS}} />
            <div className='Footer__socials'>
              <a
                href='https://www.facebook.com/datawowai/'
                target='_blank'
                rel='nofollow noopener noreferrer'
                title='facebook'
                onClick={() => {
                  logEvent({
                    ga: {
                      category: 'Facebook',
                      action: 'Click Facebook',
                      label: 'Footer',
                    },
                  })
                }}
              >
                <IconFacebook />
              </a>
              <a
                href='https://www.linkedin.com/company/datawowio/'
                target='_blank'
                rel='nofollow noopener noreferrer'
                title='linkedin'
                onClick={() => {
                  logEvent({
                    ga: {
                      category: 'LinkedIn',
                      action: 'Click LinkedIn',
                      label: 'Footer',
                    },
                  })
                }}
              >
                <IconLinkedin />
              </a>
            </div>
          </div>
          <div className='contact'>
            <a
              href='tel:020245560'
              onClick={() => {
                logEvent({
                  ga: {
                    category: 'Phone',
                    action: 'Click Phone',
                    label: 'Footer',
                  },
                })
              }}
            >
              โทร: 02-024-5560
            </a>
            <strong>
              <a
                href='mailto:sales@datawow.io'
                onClick={() => {
                  logEvent({
                    ga: {
                      category: 'Email',
                      action: 'Click Email',
                      label: 'Footer',
                    },
                  })
                }}
              >
                sales@datawow.io
              </a>
            </strong>

            <iframe
              src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3876.072195349628!2d100.58990201483007!3d13.714077190371894!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29feb33e83421%3A0xfe14120eb3d8af4f!2sData%20Wow!5e0!3m2!1sen!2sth!4v1585543617852!5m2!1sen!2sth'
              title='map'
              allowFullScreen
            />
          </div>
        </div>
        <div className='container__form' id='contact'>
          <Form title='<h3>ปรึกษาผู้เชี่ยวชาญ <span>ฟรี</span></h3>' />
        </div>
      </div>
    </div>
  )
}

export default SiteFooterWithForm
